import { render, staticRenderFns } from "./CourseThumb.vue?vue&type=template&id=5b13e260&"
import script from "./CourseThumb.vue?vue&type=script&lang=ts&"
export * from "./CourseThumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports